<template>
<div class="home-content">
  <heads :logo="logo"></heads>

  <div class="home-nav">
    <div class="home-nav-content">
      <div class="logo-home"><img :src="globalConfig.imgUrl+logo"/></div>
      <div class="home-game" :class="[is_type==0? 'colorActive':'']" @click.stop="_clickGame('home')"><span><img src="../assets/img/home.png"/></span><span class="home-game-title">{{$t('home.index')}}</span></div>
      <div class="home-game" :class="[is_type==item.id? 'colorActive':'']" v-for="item in list" @click.stop="_clickGame(item.category_abbr,item.id)"><span><img :src="globalConfig.imgUrl+item.picture_mobile"/></span><span class="home-game-title">{{item.category_name}}</span></div>
    </div>
  </div>
  <div class="home-banner" v-if="adList.length>0">
    <swiper  :options="swiperOptions" v-if="adList.length>1">
      <swiper-slide v-for="(item,index) in adList" :key="index"><img :src="globalConfig.imgUrl+item.picture_web"/></swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div v-if="adList.length>0 && adList.length===1" v-for="(item,index) in adList"><img :src="globalConfig.imgUrl+item.picture_web"/></div>
  </div>

  <div class="game-content" v-if="isHomeIndex==1">

    <div class="tournament-sticker" v-if="marqueeList.length>0">
      <div class="tournament-sticker-tip">赢家</div>
      <div class="tournament-sticker-center">

        <div class="tournament-sticker-position" :class="{marquee_top:animate}">
          <div class="tournament-sticker-item" v-for="(item,index) in marqueeList" @click.stop="_day_urk">
            <div class="tournament-sticker-icon">
              {{item.platform_abbr}}
            </div>
            <div class="tournament-sticker-name">
              {{ item.username }}
            </div>
            <div class="tournament-sticker-amount">+{{item.win}}</div>

          </div>
        </div>
      </div>
    </div>


    <div class="game-list" v-if="jack_list.length>0">
      <div class="game-list-title"><span><img src="../assets/img/icon-jackpot.png" class="jack-icon"/></span><span>{{$t('home.game')}}</span></div>
      <div class="jack-content">
        <div class="jack-list" v-for="(item,index) in jack_list">
          <div class="jack-list-center" :class="[index==0 || index==1? 'border-jack':'']">
            <div class="jack-list-title jack-color"><span>{{item.classify_name}}</span><span class="jack-amount"><em class="icon-title"></em>{{item.jackpot_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span><span class="game-more jack-amount" @click.stop="_more('jack',item.id)">{{$t('home.more')}}</span></div>
            <div class="jack-item">
              <div class="jack-item-center" v-for="items in item.kinds"><div @click.stop="_HotClick($event)" :data-maintain="items.is_maintain" :data-classifyid="items.classify_id" :data-platformid="items.platform_id" :data-kindid="items.id" :data-platformabbr="items.platform_abbr" :data-isown="items.is_own"><img :src="globalConfig.imgUrl+items.kind_picture"/><span class="jack-item-title">{{items.kind_name}}</span></div></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="game-list" v-if="hot_list.length>0">
      <div class="game-list-title"><span class="icon-hot"></span><span>{{$t('home.hot')}}</span><span class="game-more" @click.stop="_more('hot')">{{$t('home.more')}}</span></div>
        <div class="game-item">
          <div v-for="item in hot_list" class="game-item-list"><div @click.stop="_HotClick($event)" :data-maintain="item.is_maintain" :data-classifyid="item.classify_id" :data-platformid="item.platform_id" :data-kindid="item.id" :data-platformabbr="item.platform_abbr" :data-isown="item.is_own"><span><img :src="globalConfig.imgUrl+item.kind_picture"/></span><span class="game-item-title">{{item.kind_name}}</span></div></div>
        </div>
    </div>
 <!--   <div class="game-list" v-if="live_list.length>0">
      <div class="game-list-title"><span class="icon-live"></span><span>{{$t('home.live')}}</span><span class="game-more" @click.stop="_more('live')">{{$t('home.more')}}</span></div>
      <div class="game-item">
        <div v-for="item in live_list" class="game-item-list"><div @click.stop="_HotClick($event)" :data-maintain="item.is_maintain" :data-classifyid="item.classify_id" :data-platformid="item.platform_id" :data-kindid="item.id" :data-platformabbr="item.platform_abbr" :data-isown="item.is_own"><span><img :src="globalConfig.imgUrl+item.kind_picture"/></span><span class="game-item-title">{{item.kind_name}}</span></div></div>
      </div>
    </div>-->

    <div class="game-list" v-if="new_list.length>0">
      <div class="game-list-title"><span class="icon-new"></span><span>{{$t('home.new')}}</span><span class="game-more" @click.stop="_more('new')">{{$t('home.more')}}</span></div>
      <div class="game-item">
        <div v-for="item in new_list" class="game-item-list new-item"><div @click.stop="_HotClick($event)" :data-maintain="item.is_maintain" :data-classifyid="item.classify_id" :data-platformid="item.platform_id" :data-kindid="item.id" :data-platformabbr="item.platform_abbr" :data-isown="item.is_own"><span><img :src="globalConfig.imgUrl+item.kind_picture"/></span><span class="game-item-title">{{item.kind_name}}</span></div></div>
      </div>
    </div>
    <div class="game-list" v-if="electronic_list.length>0">
      <div class="game-list-title"><span class="icon-slot"></span><span>{{$t('home.slot')}}</span><span class="game-more" @click.stop="_more('electronic')">{{$t('home.more')}}</span></div>
      <div class="game-item">
        <div v-for="item in electronic_list" class="game-item-list new-item"><div @click.stop="_HotClick($event)" :data-maintain="item.is_maintain" :data-classifyid="item.classify_id" :data-platformid="item.platform_id" :data-kindid="item.id" :data-platformabbr="item.platform_abbr" :data-isown="item.is_own"><span><img :src="globalConfig.imgUrl+item.kind_picture"/></span><span class="game-item-title">{{item.kind_name}}</span></div></div>
      </div>
    </div>
    <div class="game-list" v-if="fish_list.length>0">
      <div class="game-list-title"><span class="icon-fish"></span><span>{{$t('home.fish')}}</span><span class="game-more" @click.stop="_more('fish')">{{$t('home.more')}}</span></div>
      <div class="game-item">
        <div v-for="item in fish_list" class="game-item-list new-item"><div @click.stop="_HotClick($event)" :data-maintain="item.is_maintain" :data-classifyid="item.classify_id" :data-platformid="item.platform_id" :data-kindid="item.id" :data-platformabbr="item.platform_abbr" :data-isown="item.is_own"><span><img :src="globalConfig.imgUrl+item.kind_picture"/></span><span class="game-item-title">{{item.kind_name}}</span></div></div>
      </div>
    </div>
    <div class="game-list" v-if="poker_list.length>0">
      <div class="game-list-title"><span class="icon-rng"></span><span>{{$t('home.rng')}}</span><span class="game-more" @click.stop="_more('poker')">{{$t('home.more')}}</span></div>
      <div class="game-item">
        <div v-for="item in poker_list" class="game-item-list new-item"><div @click.stop="_HotClick($event)"  :data-maintain="item.is_maintain" :data-classifyid="item.classify_id" :data-platformid="item.platform_id" :data-kindid="item.id" :data-platformabbr="item.platform_abbr" :data-isown="item.is_own"><span><img :src="globalConfig.imgUrl+item.kind_picture"/></span><span class="game-item-title">{{item.kind_name}}</span></div></div>
      </div>
    </div>

  </div>
  <div v-else-if="isHomeIndex==2" class="game-content">
    <div class="game-box">
      <div class="game-box-center">
        <div v-for="item in game_list" :class="[game_id==item.id ? 'colorGame':'']" @click.stop="_kindChange(item.id,item.is_jackpot,item.jackpot_amount,item.jackpot_major_amount)"><span><em><img :src="globalConfig.imgUrl+item.picture_web"/></em><em>{{item.platform_abbr}}</em></span></div>
      </div>
    </div>
    <div class="game-jack" v-if="is_jackpot==1">
      <div class="game-jack-logo"><img :src="globalConfig.imgUrl+game_Url"/></div>
      <div class="game-jack-tip game-jack-title">
        <span class="game-box-slot">{{jackpot_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}<em class="game-box-icon" ><img src="../assets/img/jackpotList-btn.png" @click.stop="_winning"/></em></span>
      </div>
      <div class="major" >
        {{jackpot_major_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}
      </div>
    </div>
    <div class="kind-list">
      <div v-for="item in game_kind" class="kind-list-item" :class="[item.is_jackpot==1? 'kind-jack-icon':'']">
        <div @click.stop="_join($event)" :data-iskind="is_kind" :data-gameid="item.id" :data-platformid="item.platform_id" :data-classifyid="item.id" :data-isjoin="item.is_join" :data-ismaintain="item.is_maintain" :data-issingle="item.is_single" :data-platformabbr="item.platform_abbr" :data-isown="item.is_own"><img :src="globalConfig.imgUrl+item.kind_picture" class="kind-list-icon" v-if="is_kind==1"/><img :src="globalConfig.imgUrl+item.picture_web" class="kind-list-icon" v-else/><span class="kind-list-title" v-if="is_kind==1">{{item.kind_name}}</span><span class="kind-list-title" v-else>{{item.classify_name}}</span></div>
      </div>
    </div>
    <div class="kind_more" v-if="isRoll==false"><span class="kind_more_color" @click.stop="_newKind">{{$t('home.more')}}</span></div>
  </div>
  <div class="game-content" v-else-if="isHomeIndex==3">
    <div class="kind-list">
      <div v-for="item in more_list" class="kind-list-item"><div  @click.stop="_HotClick($event)"  :data-maintain="item.is_maintain" :data-classifyid="item.classify_id" :data-platformid="item.platform_id" :data-kindid="item.id" :data-platformabbr="item.platform_abbr" :data-isown="item.is_own"><img :src="globalConfig.imgUrl+item.kind_picture" class="kind-list-icon"/><span class="kind-list-title">{{item.classify_name}}</span></div></div>
    </div>
    <div class="kind_more" v-if="isRoll==false"><span class="kind_more_color" @click.stop="_newKind">{{$t('home.more')}}</span></div>
  </div>
  <div class="game-content" v-if="isHomeIndex==4" style="width: 1120px">
    <div class="game-person">
      <div class="game-person-item" v-for="item in game_list">
        <div @click.stop="_join($event)" :data-iskind="item.is_kind" :data-gameid="item.id" :data-platformid="item.platform_id" :data-classifyid="item.id" :data-isjoin="item.is_join" :data-ismaintain="item.is_maintain" :data-issingle="item.is_single" :data-platformabbr="item.platform_abbr" :data-isown="item.is_own"><img :src="globalConfig.imgUrl+item.picture_web" class="game-person-icon"/></div>
      </div>
    </div>
  </div>
  <div class="game-content" v-else-if="isHomeIndex==5" style="width: 1120px">
    <div class="home-discount" v-for="item in discountList">
      <div class="home-discount-center">
        <div class="home-discount-img"><img :src="globalConfig.imgUrl+item.picture_web"/></div>
        <div class="home-discount-title">
          <div class="home-discount-tip">{{item.title}}</div>
          <div class="home-discount-more" @click.stop="_openDis(1,item.id)">{{$t('home.more')}}</div>
        </div>
      </div>
    </div>

  </div>
  <div v-if="discountOpen" class="home-cover"><!--优惠详情-->
    <div class="home-cover-center">
      <div class="home-cover-left">
        <div class="home-cover-title">
          <img :src="globalConfig.imgUrl+openDisIcon"/>
          <h4>{{openDisText}}</h4>
        </div>
        <div class="home-cover-text">
          <div class="home-cover-text-div" v-if="openDisContent!=''" v-html="openDisContent"></div>
        </div>
      </div>
      <div class="home-cover-right" @click.stop="_openDis(2)"></div>
    </div>
  </div>
  <div class="home-cover" v-if="isPop==1"><!--弹窗-->
    <div class="home-pop">
      <div class="home-pop-left">
        <div class="home-pop-center">
          <div class="home-pop-title">
            <div v-for="item in popList" :class="[item.id==popId?'popColor':''] " @click.stop="_popCheck(1,item.id)">{{item.title}}</div>

          </div>
          <div class="home-pop-content">
            <img :src="globalConfig.imgUrl+popIcon" class="home-pop-icon"/>
            <div class="home-pop-tip">{{popTitle}}</div>
            <div class="home-pop-text" v-html="popText"></div>
          </div>
        </div>
      </div>
      <div class="home-pop-close" @click.stop="_popCheck(2)"></div>
    </div>
  </div>
  <div class="home-cover" v-if="isWin">
    <div class="major_cover-center">
      <div class="major_cover-title">
        <div class="major-gameTab">
          <span class="icon-slot"></span>
        </div>
        <span class="home-pop-close" @click.stop="_hideWin"></span>
      </div>
      <div class="major-list-title">
        <div>{{$t('home.t_1')}}</div>
        <div>{{$t('home.t_2')}}</div>
      </div>
      <div class="major-list">
        <div v-for="item in winningList"><span><em>{{item.bet_time}}</em><em>{{(item.user.username)}}</em></span><span>{{item.jackpot}}</span></div>
      </div>
    </div>
  </div>


  <div class="webView" v-show="isView">
    <iframe frameborder="no" id="embedgameIframe" allowfullscreenallow="fullscreen" scrolling="no" frameBorder="0" style="margin: 0; padding: 0; white-space: nowrap; border: 0; width:100%;height:100%" :src="viewUrl"></iframe>
    <drag-it-dude @activated="handleActivated" @dragging="handleDragging" @dropped="handleDropped"><img src="../assets/img/main.png" @click.stop="_back" class="closeIcon" /></drag-it-dude>
  </div>

</div>
</template>

<script>
  import heads from './navs/headr'
  import DragItDude from 'vue-drag-it-dude'
    export default {
        name: "home",
      components:{heads,DragItDude},
      data(){
          return{
            list:[],
            adList:[],
            swiperOptions:{
              observer:true,//修改swiper自己或子元素时，自动初始化swiper
              observeParents:true,//修改swiper的父元素时，自动初始化swiper
              loop:true,
              autoplay: {
                delay: 3000,
                disableOnInteraction: false
              }
            },
            kind_type:['hot','new','sport','fish'],/*'live' poker*/
            hot_list:[],
            live_list:[],
            jack_list:[],
            new_list:[],
            electronic_list:[],
            fish_list:[],
            poker_list:[],
            platform_id:'',
            classify_id:'',
            isClick:false,
            isHomeIndex:1,
            game_list:[],
            game_id:'',
            game_Url:'',
            game_kind:[],
            page:0,
            is_kind:0,
            curPage:0,
            last_Page:0,
            isRoll:true,
            is_type:0,
            more_list:[],
            more_type:'',
            jack_id:'',
            isToken:false,
            username:'',
            balance:'',
            phone:'',
            withdraw_bet_quota:'',
            logo:'',
            is_jackpot:0,
            jackpot_amount:0,
            jackpot_major_amount:0,
            discountList:[],
            discountOpen:false,
            openDisIcon:'',
            openDisText:'',
            openDisContent:'',
            popList:[],
            isPop:0,
            popIcon:"",
            popText:'',
            popTitle:'',
            popId:'',
            winningList:[],
            isWin:false,
            isMajor:false,
            isView:false,
            viewUrl:'',
            animate:false,
            marqueeList:[]

          }
      },
      created:function(){
          let _self=this;
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            _self._category();
            _self._banner();
            _self._kind_type();
            _self._jackpot();
            _self._config();
            _self._popup();
            _self._query_by_day();
          }else{
            _self.$router.push({path:'/Login'})
          }

      },
      methods:{
        _day_urk:function (){
          let _self=this;
          this.$router.push({path:'/playerRankRecord'})
        },
        _query_by_day:function (){
          let _self=this;
          var data = new Date();

          var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
          var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
          var time = data.getFullYear() + "-" + month + "-" + date;

          this._PublicFun.getData('1', 'get', 'win_top/query_by_day?search_date='+time, {}, function (result) {
            if (result.data['status_code'] == 200) {
              _self.marqueeList=result.data['data'];
              if(_self.marqueeList.length>0){
                setInterval(_self.showMarquee, 2000)
              }
            }
          })

        },
        showMarquee: function () {
          this.animate = true;
          setTimeout(()=>{
            this.marqueeList.push(this.marqueeList[0]);
            this.marqueeList.shift();
            this.animate = false;
          },500)},
        handleActivated() {
          /*this.text = "I am ready for great things!";*/
        },
        handleDragging() {
          /* this.text = "Weeee!";*/
        },
        handleDropped() {
          /*this.text = "That's place is awesome!";*/
          setTimeout(() => {
            /* this.text = "Just move me!";*/
          }, 3000);
        },
        _back:function(){
          window.location.reload()
        },
        _winning:function(){
          let _self=this;
          if(_self.isMajor)
            return false;
          _self.isMajor=true;
          this._PublicFun.getData('1', 'get', 'jackpot/winning/'+_self.game_id, {}, function (result) {
            if (result.data['status_code'] == 200) {
              _self.winningList=result.data['data'];
              _self.isWin=true;
              _self.isMajor=false;
            }else{
              Toast(result.data['message']);
              _self.isMajor=false;
            }
          })

        },
        _hideWin:function(){
          let _self=this;
          _self.isWin=false;
        },
        _popup:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'article/6', {}, function (result) {
            if(result.data['status_code']==200){
              _self.popList=result.data['data'];
              if(_self.popList.length>0){
                _self.isPop=1;
                _self.popTitle=_self.popList[0].title;
                _self.popIcon=_self.popList[0].picture_web;
                _self.popText=_self.popList[0].content;
                _self.popId=_self.popList[0].id;
              }else{
                _self.isPop=0;
              }


            }

          })
        },
        _popCheck:function(m,id){
          let _self=this;
          if(m==1){
            _self.popTitle='';
            _self.popIcon='';
            _self.popText='';
            _self.popId=id;
            for(var i=0;i<_self.popList.length;i++){
              if(_self.popList[i].id==id){
                _self.popTitle=_self.popList[i].title;
                _self.popIcon=_self.popList[i].picture_web;
                _self.popText=_self.popList[i].content;
                _self.popId=_self.popList[i].id;
              }
            }
          }else if(m==2){
            _self.isPop=0;
          }
        },
        _openDis:function(m,id){
          let _self=this;
          if(m==1){
            for(var i=0;i<_self.discountList.length;i++){
              if(_self.discountList[i].id==id){
                _self.openDisIcon=_self.discountList[i].picture_web;
                _self.openDisText=_self.discountList[i].title;
                _self.openDisContent=_self.discountList[i].content;
                _self.discountOpen=true;
              }
            }
          }else if(m==2){
            _self.discountOpen=false;
          }
        },
        _discount:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'article/4', {}, function (result) {
            if(result.data['status_code']==200){

              _self.discountList=result.data['data'];
            }
          })
        },
        _config:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'site/config', {}, function (result) {
            if(result.data['status_code']==200){
              _self.logo=result.data['data'].logo;
            }
          })
        },
        _user:function () {
          let _self=this;
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            this._PublicFun.getData('2', 'get', 'user', {}, function (result) {
              if(result.data['status_code']==200){
                _self.GLOBAL.save('user',result.data['data']);
                _self.username=result.data['data'].username;
                _self.balance=result.data['data'].balance;
                _self.phone=result.data['data'].phone;
                _self.withdraw_bet_quota=result.data['data'].withdraw_bet_quota;
                _self.isToken=true;
              }

            })
          }else{
            _self.isToken=false;
          }
        },
        _more:function(type,id){
          let _self=this;
          _self.more_type=type;
          _self.more_list=[];
          _self.curPage=0;
          _self.last_Page=0;
          _self.isRoll=true;
          _self.isHomeIndex=3;
          if(type=='jack'){
            _self.jack_id=id;
            _self._jack_list();
          }else{
            _self._more_list();
          }
        },
        _more_list:function(){
          let _self=this;
          let page = parseFloat(_self.curPage) + 1;
          _self.curPage = page;
          if (_self.last_Page == 0) {
            _self.last_Page = page;
          }
          let num=1;
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            num=2;
          }
          this._PublicFun.getData(num, 'get', 'category/'+_self.more_type+"?page="+page, {}, function (result) {
            if(result.data['status_code']==200){
              let meta = result.data['meta'];
              let current_page = meta.current_page;
              if (current_page == 1) {
                _self.more_list = [];
              }
              if (result.data['data'].length > 0) {
                for (let i = 0; i < result.data['data'].length; i++) {
                  _self.more_list.push(result.data['data'][i]);
                }
              }
              if (meta.last_page <= page) {
                _self.isRoll = true;

              } else {
                _self.last_Page = meta.last_page;
                _self.isRoll = false;
              }
            }

          })
        },
        _jack_list:function(){
          let _self=this;
          let page = parseFloat(_self.curPage) + 1;
          _self.curPage = page;
          if (_self.last_Page == 0) {
            _self.last_Page = page;
          }
          let num=1;
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            num=2;
          }
          this._PublicFun.getData(num, 'get', 'jackpot/kind/'+_self.jack_id+"?page="+page, {}, function (result) {
            if(result.data['status_code']==200){
              let meta = result.data['meta'];
              let current_page = meta.current_page;
              if (current_page == 1) {
                _self.more_list = [];
              }
              if (result.data['data'].length > 0) {
                for (let i = 0; i < result.data['data'].length; i++) {
                  _self.more_list.push(result.data['data'][i]);
                }
              }
              if (meta.last_page <= page) {
                _self.isRoll = true;

              } else {
                _self.last_Page = meta.last_page;
                _self.isRoll = false;
              }
            }

          })
        },
        _clickGame:function(type,id){
          let _self=this;
          _self.curPage=0;
          _self.last_Page=0;
          _self.isRoll=true;
          if(type=='home'){
            _self.isHomeIndex=1;
            _self.is_type=0;
          }else if(type=='turntable' || type=='sign_in' || type=='sales_promotion' || type=='app_download'){
            _self.is_type=id;

            if(type=='sales_promotion'){
              _self.discountList=[];
              _self._discount();
              _self.isHomeIndex=5;
            }
          }else{
            _self.is_type=id;

            if(type=='live' || type=='sport'){
              _self.isHomeIndex=4;
            }else{
              _self.isHomeIndex=2;
            }
            _self.game_list=[];
            for(var i=0;i<_self.list.length;i++){
              if(id==_self.list[i].id){
                _self.game_list=_self.list[i].classify;
                if(type=='live' || type=='sport'){

                }else{
                  _self.game_id=_self.game_list[0].id;
                  _self.jackpot_amount=_self.game_list[0].jackpot_amount;
                  _self.jackpot_major_amount=_self.game_list[0].jackpot_major_amount;
                  _self.is_jackpot=_self.game_list[0].is_jackpot;
                  _self._kind();
                }

              }
            }
          }
        },
        _kind:function(){
          let _self=this;
          _self.game_kind=[];
          for(var i=0;i<_self.game_list.length;i++){
            if(_self.game_id==_self.game_list[i].id){
              _self.is_kind=_self.game_list[i].is_kind;
              _self.game_Url=_self.game_list[i].picture_web;
              if(_self.game_list[i].is_kind==1){
                _self._kindMore();
              }else{
                _self.game_kind.push(_self.game_list[i]);

              }
            }
          }

        },
        _kindMore:function(){
          let _self=this;
          let page = parseFloat(_self.curPage) + 1;
          _self.curPage = page;
          if (_self.last_Page == 0) {
            _self.last_Page = page;
          }
          let num=1;
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            num=2;
          }
          this._PublicFun.getData(num, 'get', 'kind/'+_self.game_id+"?page="+page, {}, function (result) {
            if(result.data['status_code']==200){
              let meta = result.data['meta'];
              let current_page = meta.current_page;
              if (current_page == 1) {
                _self.game_kind = [];
              }
              if (result.data['data'].length > 0) {
                for (let i = 0; i < result.data['data'].length; i++) {
                  _self.game_kind.push(result.data['data'][i]);
                }
              }
              if (meta.last_page <= page) {
                _self.isRoll = true;

              } else {
                _self.last_Page = meta.last_page;
                _self.isRoll = false;
              }
            }

          })
        },
        _newKind:function(){
          let _self=this;
          _self.isRoll=true;
          if(_self.isHomeIndex==2){
            _self._kindMore();
          }else if(_self.isHomeIndex==3){
            if(_self.more_type=='jack'){
              _self._jack_list();
            }else{
              _self._more_list();
            }
          }

        },
        _kindChange:function(id,is_jackpot,jackpot_amount,jackpot_major_amount){
          let _self=this;
          _self.curPage=0;
          _self.last_Page=0;
          _self.isRoll=true;
          _self.kind_game=[];
          _self.game_id=id;
          _self.is_jackpot=is_jackpot;
          _self.jackpot_amount=jackpot_amount;
          _self.jackpot_major_amount=jackpot_major_amount
          _self._kind();
        },
        _join:function(e){
          let _self=this;
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            let name=e.currentTarget.dataset;
            let iskind=name.iskind;
            let is_join='';
            let issingle='';
            let ismaintain=name.ismaintain;
            let platform_abbr='';
            let is_own='';
            if(iskind==0){
              issingle=name.issingle;
              is_join=name.isjoin;
              ismaintain=name.ismaintain;
              _self.platform_id=name.platformid;
              _self.classify_id=name.classifyid;
              platform_abbr=name.platformabbr;
              is_own=name.isown;
            }else{
              let game_list=_self.game_list;
              for(var i=0;i<game_list.length;i++){
                if(_self.game_id==game_list[i].id){
                  issingle=game_list[i].is_single;
                  is_join=game_list[i].is_join;
                  ismaintain=game_list[i].is_maintain;
                  platform_abbr=game_list[i].platformabbr;
                  is_own=game_list[i].isown;
                  _self.platform_id=game_list[i].platform_id;
                  _self.classify_id=game_list[i].id;
                }
              }
            }
            if(is_join==1){
              if(ismaintain==0){
                if(platform_abbr=='THAL' && is_own==1){
                  _self.$router.push({path:'/THAL/index?id='+_self.platform_id})
                }else{
                  if(iskind==1){
                    let game_id=name.gameid;
                    Indicator.open();
                    _self._openKindGame(game_id)
                  }else{
                    if(issingle==1){
                      Indicator.open();
                      _self._openGame();
                    }else{

                    }
                  }
                }


              }else{
                Toast(_self.$t('home.maintain'))
              }
            }else{
              Toast(_self.$t('home.await'))
            }

          }else{
            Toast(_self.$t('home.login'));
            _self.$router.push({path:'/Login'})
          }


        },
        _HotClick:function(e){
          let _self=this;
          let name=e.currentTarget.dataset;
          let token=_self.GLOBAL.fetch('token');
          let maintain=name.maintain;
          _self.classify_id=name.classifyid;
          let id=name.kindid;
          _self.platform_id=name.platformid;
          let platform_abbr=name.platformabbr;
          let is_own=name.isown;
          if(token.length!=0){
            if(maintain==1){
              Toast(_self.$t('home.maintain'))
            }else{
              if(platform_abbr=='THAL' && is_own==1){
                _self.$router.push({path:'/THAL/index?id='+_self.platform_id})
              }else{
                _self._openKindGame(id);
              }

            }
          }else{
            Toast(_self.$t('home.login'));
            _self.$router.push({path:'/Login'})
          }
        },
        _openKindGame:function(id){
          let _self=this;
          if(_self.isClick)
            return false;
          _self.isClick=true;
          this._PublicFun.getData('2', 'get', 'classify/open/'+_self.platform_id+'?classify_id='+_self.classify_id+"&kind_id="+id, {}, function (result) {
            if(result.data['status_code']==200){
              _self.isClick=false;
              Indicator.close();
              _self.viewUrl=result.data['data'].jump_url;
              _self.isView=true;
              /* _self._open(2);*/
              //tempPage.close();
             /* window.open(result.data['data'].jump_url)*/

            }else{
              Toast(result.data['message']);
              Indicator.close();
              _self.isClick=false;

            }
          })
        },
        _openGame:function () {//进入游戏
          let _self=this;
          if(_self.isClick)
            return false;
          _self.isClick=true;
          this._PublicFun.getData('2', 'get', 'classify/open/'+_self.platform_id+'?classify_id='+_self.classify_id, {}, function (result) {
            if(result.data['status_code']==200){
              _self.isClick=false;
              Indicator.close();
              _self.viewUrl=result.data['data'].jump_url;
              _self.isView=true;
              /* _self._open(2);*/
              //window.open(result.data['data'].jump_url,'_blank')
              /*window.open(result.data['data'].jump_url)*/
            }else{
              Indicator.close();
              _self.isClick=false;
              Toast(result.data['message']);
            }
          })
        },
        _category:function () {
          let _self=this;
          let num=1;
          let token=_self.GLOBAL.fetch('token');
          if(token.length!=0){
            num=2;
          }
          this._PublicFun.getData(num, 'get', 'category', {}, function (result) {
            if(result.data['status_code']==200){
              _self.list=result.data['data'];
            }
          })
        },
        _banner:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'ad', {}, function (result) {
            if(result.data['status_code']==200){
              _self.adList=result.data['data'];
            }

          })
        },
        _urlPath:function(url){
          var s=url;
          var final = s.substr(s.lastIndexOf('/') + 1);
          return final
        },
        _kind_type:function(){
          let _self=this;
          let arr=[];
          for(var i=0;i<_self.kind_type.length;i++){
            let res=this._PublicFun.spread('category/'+_self.kind_type[i],'get','');
            arr.push(res)
          }
          this._PublicFun.all(arr,function (result) {
            for(var i=0;i<result.length;i++){
              var res=result[i].data;
              if(res.status_code==200){
                var path_type=_self._urlPath(res.meta.path);
                if(path_type=='hot'){
                  _self.hot_list=res.data;
                }else if(path_type=='live'){
                  _self.live_list=res.data;
                }else if(path_type=='new'){
                  _self.new_list=res.data;
                }else  if(path_type=='electronic'){
                  _self.electronic_list=res.data;
                }else if(path_type=='fish'){
                  _self.fish_list=res.data;
                }else if(path_type=='poker'){
                  _self.poker_list=res.data;
                }
              }
            }
          })
        },
        _jackpot:function(){
          let _self=this;
          this._PublicFun.getData('2', 'get', 'jackpot/top', {}, function (result) {
            if(result.data['status_code']==200){
              _self.jack_list=result.data['data'];
            }
          })
        },
      }
    }
</script>

<style scoped>
@import "../assets/css/home.css";
.webView{
  position: fixed;
  z-index: 99;
  top: 0;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: #000000;
}
.closeIcon{
  width: 50px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue